/* dewamodule */
define( 'bootstrap',[ 'jquery', 'component', 'helper', 'breakpoint', 'form', 'journey', 'lib/utils', 'hayak-popup', 'format-numbers', 'vendor/moment' ],
	function ( $, component, helper, breakpoint, Form, journey, utils, hayakPopup, formatNumbers, moment ) {

		'use strict';

		/**
		 * Application entry point: Initialises all components and implements any other global behaviours.
		 * @module
		 */

		// add js classname to html tag
		document.getElementsByTagName( 'html' )[ 0 ].className = 'js';

		// initialise breakpoints
		breakpoint.init();

		// initialise components
		component.init();

		// initialise helpers
		helper.init();

		// initialise forms
		$( '[data-form]' ).each( function () {
			( new Form( $( this ) ) ).init();
		} );

		// initialise journeys
		journey.init();

		// init hayak popup click events
		hayakPopup.init();

		// init auto currency formatting
		formatNumbers.init();

		// disable tel links in IE
		if ( utils.isMSIE() ) {

			$( 'a[href^=tel]' ).each( function () {

				var $link = $( this );
				$link.addClass( 'link--inactive-tel' );
				$link.on( 'click', function ( e ) {
					e.preventDefault();
				} );
			} );
		}

		// init re-rendered components
		window.initComponents = function ( id ) {

			var $components,
				$helpers,
				$journeys,
				$newInitBlock;

			// prevent calling anything again if no id is passed
			if ( typeof ( id ) !== 'undefined' ) {

				$newInitBlock = $( '#' + id );

				$components = $newInitBlock.find( '[ data-component ]' );
				$helpers = $newInitBlock.find( '[ data-helper ]' );
				$journeys = $newInitBlock.find( '[ data-journey ]' );

				component.init( $components );
				helper.init( $helpers );
				journey.init( $journeys );

			}
		};
 
        function createCookie(name, value, days) {
            var expires;
 
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "";
            }
            document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
        }
 
        function readCookie(name) {
            var nameEQ = encodeURIComponent(name) + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ')
                    c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0)
                    return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
            return null;
        }
 
        function eraseCookie(name) {
            createCookie(name, "", -1);
        }
 
        jQuery("input").on("keyup", function (e) {
            var value = $(this).val() || "";
            var regex = /<(\/?\w+[^\n>]*\/?)>/ig;
            if (regex.test(value)) {
                //jQuery(this).val(value.replace(regex, "&lt;$1&gt;"));
                jQuery(this).val('');
                e.preventDefault();
                return false;
            }
        });

		$('[button-more]').each(function () {
			$(this).off('click.buttonmore').on('click.buttonmore', function () {
				$('.button-more--container').removeClass('opened');
				$(this).find('.button-more--container').toggleClass('opened');
			});
		});

		$('[data-nav-target]').each(function () {
			$(this).off('click.navto').on('click.navto', function () {
				var $target = $($(this).attr('data-nav-target'));

				$('html, body').animate({
                    scrollTop: $target.offset().top - jQuery('.m12-masthead').outerHeight(true) - 110
                }, 400);
			});
		});

		$(document).off('click.ddclosemore').on('click.ddclosemore', function (event) {
			if (!$(event.target).is('[button-more]')) {
				$('.button-more--container').removeClass('opened');
			};
		});
	});

